module.exports = __webpack_public_path__ + "static/img/89-2.9a1fd31.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/89-2.jpg
// module id = KSVJ
// module chunks = 0